import { render, staticRenderFns } from "./ParentalGuardianship.vue?vue&type=template&id=7dcefe50&"
import script from "./ParentalGuardianship.vue?vue&type=script&lang=js&"
export * from "./ParentalGuardianship.vue?vue&type=script&lang=js&"
import style0 from "./ParentalGuardianship.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports